// extracted by mini-css-extract-plugin
module.exports = {"layout":"User_layout_3FCf4","main":"User_main_F7Hun","left":"User_left_MDF1i","right":"User_right_38o5l"};